<template>
    <div class="card" :class="{ 'shadow': $route.params.client }">
        <div class="card-body">
            <div class="demo-inline-spacing mb-1">
                <button v-if="!showAttackDetail" type="button" @click="bulkDeleteAttack" class="btn btn-outline-danger mt-0">Bulk Delete</button>
                <button
                    type="button"
                    v-if="showAttackDetail"
                    @click="showAttackDetail = !showAttackDetail"
                    class="btn btn-outline-info mt-0"
                >
                    Go Back
                </button>
            </div>
            <vue-good-table
                v-if="!showAttackDetail"
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:per-page-change="onPerPageChange"
                v-on:selected-rows-change="attackSelectionChanged"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: true,
                }"
                :search-options="{
                    enabled: true,
                    externalQuery: searchTerm
                }"
                :select-options="{
                    enabled: true,
                    disableSelectInfo: true,
                    selectOnCheckboxOnly: true
                }"
            >
                <template #table-row="props">
                    <span v-if="props.column.field === 'documents_count'">
                        <div class="badge badge-success">
                            {{ props.row.letters.length }} Attachments
                        </div>
                    </span>
                    <span v-if="props.column.field === 'action'">
                        <div class="d-flex align-items-center col-actions">
                            <a class="mr-1 text-primary" @click="viewAttack(props.row.id)" data-toggle="tooltip" data-placement="top" title="View Attack Detail">
                                <vue-feather type="eye"></vue-feather>
                            </a>
                            <a class="mr-1 text-primary" @click="downloadAttack(props.row.id)" data-toggle="tooltip" data-placement="top" title="Download Attack">
                                <vue-feather type="download"></vue-feather>
                            </a>
                            <a class="mr-1 text-primary" @click="deleteAttack(props.row.id)" data-toggle="tooltip" data-placement="top" title="Delete Attack">
                                <vue-feather type="trash"></vue-feather>
                            </a>
                        </div>
                    </span>
                </template>
            </vue-good-table>
            <timeline :id="selectedAttackId" v-if="showAttackDetail"/>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { VueGoodTable } from 'vue-good-table-next';
    import Swal from 'sweetalert2'
    import moment from 'moment';
    import Timeline from './Timeline.vue'
    export default {
        mounted() {
            this.getAttacks();
        },
        components: {
            VueGoodTable,
            Timeline
        },
        setup() {
            return {
                selectedAttackIds: reactive([]),
                moment: moment,
                showAttackDetail: ref(false),
                selectedAttackId: ref(null),
            }
        },
        watch: {
        },
        data(){
            return {
                currentPage: 1,
                currentPerPage: 10,
                totalRecords: 0,
                columns: [
                    {
                        label: 'ID',
                        field: 'id',
                    },
                    {
                        label: 'Attack Name',
                        field: 'name',
                    },
                    {
                        label: 'Documents Created',
                        field: 'documents_count',
                    },
                    {
                        label: 'Create Date',
                        field: 'created_at',
                        formatFn: this.formatDate
                    },
                    {
                        label: 'Action',
                        field: 'action',
                    }
                ],
                rows: [],
                searchTerm: '',
            };
        },
        computed: {
        },
        methods: {
            onPageChange(params) {
                this.currentPage = params.currentPage;
                this.getAttacks();
            },
            onPerPageChange(params) {
                this.currentPerPage = params.currentPerPage;
                this.currentPage = 1;
                this.getAttacks();
            },
            getAttacks() {
                let $this = this;
                let params = {};
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                }
                const route = this.$router.resolve(
                    {
                        name: 'disputes-attacks',
                        params: params
                    }
                );
                axios.get(
                    route.href,
                    {
                        params: {
                            currentPage: $this.currentPage,
                            currentPerPage: $this.currentPerPage
                        }
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.rows = response.data.data.rows
                    $this.totalRecords = response.data.data.totalRecords
                    return;
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            viewAttack(id) {
                this.selectedAttackId = id;
                this.showAttackDetail = true;
            },
            deleteAttack(id) {
                let $this = this;
                let params = {
                    attack: id
                };
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                }
                const route = this.$router.resolve(
                    {
                        name: 'attack-delete',
                        params: params
                    }
                );
                Swal.fire({
                    title: 'Are you sure you want to delete attack?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.delete(route.href)
                        .then(function(response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.currentPage = 1;
                            $this.getAttacks();
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.response_msg, 'Error!');
                        });
                    }
                });
            },
            attackSelectionChanged (params) {
                this.selectedAttackIds = _.map(params.selectedRows, 'id');
            },
            bulkDeleteAttack () {
                let $this = this;
                if ($this.selectedAttackIds.length <= 0) {
                    toastr.error("Please Select Attacks", 'Error!');
                    return;
                }
                Swal.fire({
                    title: 'Are you sure you want to delete attack?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        const route = $this.$router.resolve(
                            {
                                name: 'attacks-bulk-destroy'
                            }
                        );
                        axios.post(
                            route.href,
                            {
                                ids: $this.selectedAttackIds
                            }
                        )
                        .then(function(response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            $this.currentPage = 1;
                            $this.getAttacks();
                            toastr.success(response.data.message, 'Success!');
                            return;
                        }).catch(function(error) {
                            toastr.error(error.response.data.response_msg, 'Error!');
                        });
                    }
                });
            },
            downloadAttack (id) {
                let $this = this;
                let params = {
                    attack: id
                };
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                }
                const route = this.$router.resolve(
                    {
                        name: 'attacks-zip',
                        params: params
                    }
                );
                axios.post(route.href)
                .then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            formatDate(date)
            {
                return this.moment(date).format('llll');
            },
        }
    }
</script>